import styles from './delete-order-dialog.module.scss';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, Typography } from '@frontend-workspace/react-shared-lib';
import { t } from 'i18next';

/* eslint-disable-next-line */
export interface DeleteOrderDialogProps {
  open: boolean,
  onClose: () => void,
  onDeleteOrder: (id: string) => void,
  orderId: string
}

export function DeleteOrderDialog(props: DeleteOrderDialogProps) {
  const handleDeleteOrder = () => {
    props.onDeleteOrder(props.orderId);
    props.onClose();
  }
  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth='sm'>
      <DialogTitle className='mb-3'>
        {t("standard.areYouSureYouWantToDelete")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'>
          {/* Todo:: liste opp produkter som blir slettet.*/}
          Produkt:
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          onClick={handleDeleteOrder}
          className='minButtonWidth'>
          {t("standard.delete")}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteOrderDialog;